import { createBrowserHistory } from 'history';
import { services } from '../../app/ocab-services/services.constant';
import { modifyHistory } from '~/components/persist-token/persist-token.utils';

export const development = {
  history: modifyHistory(createBrowserHistory({
    basename: services[window.REACT_APP_SERVICE_NAME]?.basename,
  })),
  editAppointmentPaths: [ '/edit-shop', '/edit-partner', '/edit-date', '/edit-address' ],
};
